export const WHATSAPP_PREVIOUS_YEAR_URL =
  'https://api.whatsapp.com/send/?phone=525593378436&text=%C2%A1Hola!+Ya+sub%C3%AD+mi+efirma+y+solicito+la+apertura+de+cuenta+para+pagar+al+recibir+mi+devoluci%C3%B3n';
export const WHATSAPP_EFIRMA_APPOINTMENT =
  'https://api.whatsapp.com/send/?phone=525593378436&text=¡Hola!+Quiero+una+cita+para+mi+efirma';
export const WHATSAPP_NOT_PRESENTATION_URL =
  'https://api.whatsapp.com/send/?phone=525593378436&text=%C2%A1Hola!+Soy+Flex+y+me+gustaria+saber+c%C3%B3mo+puedo+mejorar+mi+resultado+del+pr%C3%B3ximo+a%C3%B1o';
export const WHATSAPP_RESULT_ASSISTANCE =
  'https://api.whatsapp.com/send/?phone=525593378436&text=%C2%A1Hola!+Vi+mi+resultado+en+la+plataforma+y+tengo+dudas';
export const WHATSAPP_RESULT_ACCOUNT_ASSISTANCE =
  'https://api.whatsapp.com/send/?phone=525593378436&text=%C2%A1Hola!+Vi+mi+resultado+en+la+plataforma+y+tengo+dudas+sobre+mi+cuenta+de+Finsocial';
export const WHATSAPP_ACCOUNT_ASSISTANCE =
  'https://api.whatsapp.com/send/?phone=525593378436&text=%C2%A1Hola!+Soy+usuario+con+plan+y+necesito+asesor%C3%ADa+fiscal';
export const WHATSAPP_OPTIMIZE_NEXT_DECLARATION =
  'https://api.whatsapp.com/send/?phone=525593378436&text=%C2%A1Hola!+Soy+usuario+con+plan+y+quiero+optimizar+mi+pr%C3%B3xima+declaraci%C3%B3n ';
export const WHATSAPP_DELETE_ACCOUNT =
  'https://api.whatsapp.com/send/?phone=525593378436&text=Hola!+Quiero+eliminar+mi+cuenta';
export const WHATSAPP_AA_HELP =
  'https://api.whatsapp.com/send/?phone=525593378436&text=%C2%A1Hola!+Tengo+dudas+sobre+mi+saldo+de+a%C3%B1os+anteriores';
